module.exports = __webpack_public_path__ + "static/media/logo_vecloud.c92f9fb3.png";